import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { AuthService } from '../../../core/services/auth.service';
import { TranslateModule } from '@ngx-translate/core';
import { DurationPipe } from '../../pipes/duration.pipe';
import { DsAlertComponent, DsBadgeComponent } from '@assecods/ng-design-system';

@Component({
  selector: 'idh-timer-toast',
  templateUrl: 'timer-toast.component.html',
  styleUrls: ['timer-toast.component.scss'],
  imports: [TranslateModule, DurationPipe, DsAlertComponent, DsBadgeComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'idh-toast',
  },
})
export class TimerToastComponent {
  private readonly authService = inject(AuthService);
  seconds = input.required<number>();

  get expireWarningKey() {
    return this.authService.sessionExpireMessageKey;
  }
}
